import { render, staticRenderFns } from "./mall-edit.vue?vue&type=template&id=35b996b9&scoped=true"
import script from "./mall-edit.vue?vue&type=script&lang=js"
export * from "./mall-edit.vue?vue&type=script&lang=js"
import style0 from "./mall-edit.vue?vue&type=style&index=0&id=35b996b9&prod&scoped=true&lang=css"
import style1 from "./mall-edit.vue?vue&type=style&index=1&id=35b996b9&prod&lang=scss&scoped=true"
import style2 from "./mall-edit.vue?vue&type=style&index=2&id=35b996b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b996b9",
  null
  
)

export default component.exports